module.exports = {
  data() {
    return {
      dateHelpers: {
        current: '',
        totalDays: '',
        businessDaysRemaining: '',
        businessDaysElapsed: ''
      },
    };
  },

  methods: {
    setDateHelpers() {
      let d = moment().subtract(1, 'days').toDate();
      this.dateHelpers.current = d.getDate();
      this.dateHelpers.totalDays = this.daysInMonth(d);
      this.dateHelpers.businessDaysElapsed = this.calcBusinessDays(moment().date(1).toDate(), d) - 1;
      this.dateHelpers.businessDaysRemaining = this.calcBusinessDays(d, moment().add(1, 'months').date(0).toDate()) - 1;
    },

    getCurrentPacing(spend, budget) {
      let pacing = spend / budget * 100;
      return `${pacing.toFixed(2)}%`;
    },

    getCurrentProjection(spend, weekends) {
      if (weekends === 1) {
        return spend / this.dateHelpers.businessDaysElapsed * (this.dateHelpers.businessDaysElapsed + this.dateHelpers.businessDaysRemaining);
      }
      return spend / this.dateHelpers.current * this.dateHelpers.totalDays;
    },

    getLeftoverPerDay(budget, spend, weekends) {
      if (weekends === 1) {
        return (budget - spend) / this.dateHelpers.businessDaysRemaining;
      }
      return (budget - spend) / (this.dateHelpers.totalDays - this.dateHelpers.current);
    },

    getCurrentProjectionForCustomRange(spend, start, end, weekends) {
      let s = moment(start);
      let e = moment(end);
      let t = moment();
      let current = t.diff(s,'days');
      let total = e.diff(s,'days') + 1;

      if (current > total) {
        return spend;
      }

      if (weekends === 1) {
        let date = moment().subtract(1, 'days').toDate();
        let elapsed = this.calcBusinessDays(s.toDate(), date) - 1;
        let remaining = this.calcBusinessDays(date, e.toDate()) - 1;

        return spend / elapsed * (remaining + elapsed);
      }
      return spend / current * total;
    },

    getLeftoverPerDayForCustomRange(budget, spend, start, end, weekends) {
      let s = moment(start);
      let e = moment(end);
      let t = moment();
      let current = t.diff(s,'days');
      let total = e.diff(s,'days') + 1;

      if (current > total) {
        return 0;
      }

      if (weekends === 1) {
        let date = moment().subtract(1, 'days').toDate();
        let elapsed = this.calcBusinessDays(s.toDate(), date, 'start') - 1;
        let remaining = this.calcBusinessDays(date, e.toDate(), 'end') - 1;

        return (budget - spend) / remaining;
      }
      return (budget - spend) / (total - current);
    },

    getLeftover(spend, budget, weekends) {
      // let pacing = this.getCurrentProjection(spend, weekends);
      return budget - spend;
    },

    getLeftoverForCustomRange(budget, spend, start, end, weekends) {
      // let pacing = this.getCurrentProjectionForCustomRange(spend, start, end, weekends);
      return budget - spend;
    },

    pacingClass(spend, budget) {
      let projection = this.getCurrentProjection(spend);
      if (projection > budget * 1.1 || projection < budget * 0.85) {
        return 'danger';
      } else if (projection > budget * 1.05 || projection < budget * 0.9) {
        return 'warning';
      }
      return 'success';
    },

    pacingClassForCustomRange(spend, budget, start, end, weekends) {
      let projection = this.getCurrentProjectionForCustomRange(spend, start, end, weekends);
      if (projection > budget * 1.05) {
        return 'danger';
      } else if (projection > budget * 1 || projection < budget * 0.9) {
        return 'warning';
      }
      return 'success';
    },

    daysInMonth(date) {
      return new Date(date.getYear(), date.getMonth() + 1, 0).getDate();
    },

    calcBusinessDays(start, end) {
      let weeks, diff, adjust = 0;
      if (end < start) return -1;
      let startWeekDay = start.getDay();
      let endWeekDay = end.getDay();
      startWeekDay = (startWeekDay === 0) ? 7 : startWeekDay;
      endWeekDay = (endWeekDay === 0) ? 7 : endWeekDay;
      if ((startWeekDay > 5) && (endWeekDay > 5)) adjust = 1;
      startWeekDay = (startWeekDay > 5) ? 5 : startWeekDay;
      endWeekDay = (endWeekDay > 5) ? 5 : endWeekDay;

      weeks = Math.floor((end.getTime() - start.getTime()) / 604800000);

      if (startWeekDay < endWeekDay) {
        diff = (weeks * 5) + (endWeekDay - startWeekDay);
      } else {
        diff = ((weeks + 1) * 5) - (startWeekDay - endWeekDay);
      }

      diff -= adjust;

      return (diff + 1);
    },
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/dashboard/pacing/mixins/datesAndPacing.js